export default "__VITE_ASSET__JUv0_do6__"